import React, { useEffect, useMemo, useState } from "react";
import { getCountdownParts, toPersianDigits } from "../../utils/liveStartCountdown";
import {
  getServerNow,
  subscribePublicAuthConfig,
} from "../../services/publicAuthConfigService";

const sizeConfig = {
  card: {
    box: "41px",
    wideBox: "43px",
    radius: "12px",
    value: "18px",
    label: "10px",
    gap: "6px",
  },
  sportCard: {
    box: "49px",
    wideBox: "52px",
    radius: "12px",
    value: "20px",
    label: "11px",
    gap: "8px",
  },
  hero: {
    box: "64px",
    wideBox: "68px",
    radius: "14px",
    value: "27px",
    label: "13px",
    gap: "10px",
  },
  detail: {
    box: "68px",
    wideBox: "72px",
    radius: "14px",
    value: "29px",
    label: "13px",
    gap: "10px",
  },
};

const labels = [
  ["days", "روز"],
  ["hours", "ساعت"],
  ["minutes", "دقیقه"],
  ["seconds", "ثانیه"],
];

const countdownTextStyle = {
  fontFamily: '"AnjomanMax", sans-serif',
  fontSynthesis: "none",
  fontVariantNumeric: "normal",
  letterSpacing: 0,
};

const LiveStartCountdown = ({ startTimestamp, size = "card", className = "", style }) => {
  const normalizedSize = sizeConfig[size] ? size : "card";
  const [now, setNow] = useState(function () {
    return getServerNow();
  });

  useEffect(() => {
    var syncNow = function () {
      setNow(getServerNow());
    };
    var unsubscribe = subscribePublicAuthConfig(syncNow);

    syncNow();

    if (!startTimestamp || startTimestamp <= getServerNow()) {
      return unsubscribe;
    }

    const interval = setInterval(() => {
      setNow(getServerNow());
    }, 1000);

    return () => {
      clearInterval(interval);
      unsubscribe();
    };
  }, [startTimestamp]);

  const diff = startTimestamp - now;

  const parts = useMemo(() => getCountdownParts(diff), [diff]);

  if (!startTimestamp || diff <= 0) return null;

  return (
    <div
      className={"legacy-live-countdown legacy-live-countdown-" + normalizedSize + (className ? " " + className : "")}
      style={style}
    >
      {labels.map(([key, label]) => {
        const value = key === "days" ? parts[key] : String(parts[key]).padStart(2, "0");

        return (
          <div className={"legacy-live-countdown-tile" + (key === "days" ? " legacy-live-countdown-tile-wide" : "")} key={key}>
            <span className="legacy-live-countdown-value" style={countdownTextStyle}>
              {toPersianDigits(value)}
            </span>
            <span className="legacy-live-countdown-label" style={countdownTextStyle}>{label}</span>
          </div>
        );
      })}
    </div>
  );
};

export default LiveStartCountdown;
